import { render, staticRenderFns } from "./bankModalUnarchive.vue?vue&type=template&id=0633974a&scoped=true"
import script from "./bankModalUnarchive.vue?vue&type=script&lang=js"
export * from "./bankModalUnarchive.vue?vue&type=script&lang=js"
import style0 from "./bankModalUnarchive.vue?vue&type=style&index=0&id=0633974a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633974a",
  null
  
)

export default component.exports